<script>
import CompanySSOAPI from "@/services/sso/company/companySSO.API";
import CompanyAPI from "@/services/company/companyAPI";
import { ROLES } from "@/helpers/roles";

export default {
  data() {
    return {
      companySelected: this.$store.getters["company/getCompany"].id
        ? this.$store.getters["company/getCompany"]
        : { id: null, uuid: null },
      companies: [],
      search: "",
      accessCompanies: [],

      page: 1,
      lastPage: 1,
      loading: true,
      searchTimer: null,
    };
  },
  methods: {
    allowAccess(id) {
      const user = this.$store.state.auth;
      const role = Number(user.info.role);

      // Roles internos/empresa: acceso total al listado de empresas.
      if (
        role === ROLES.SUPER_ROOT ||
        role === ROLES.SOPORTISTA ||
        role === ROLES.COMPANIA ||
        role === ROLES.EMPLEADO
      ) {
        return true;
      }

      // Roles asignados via SST (Cliente Admin, Talento Humano, Responsable
      // Operativo): el listado de companies ya viene filtrado desde SST.
      // Si esta en this.companies, esta permitido.
      if (
        role === ROLES.CLIENTE_ADMIN ||
        role === ROLES.TALENTO_HUMANO ||
        role === ROLES.RESPONSABLE_OPERATIVO
      ) {
        return true;
      }

      // Diseño sst (rol 2): solo empresas habilitadas via getCompanyByDesign.
      const access = this.accessCompanies.find(
        (company) => company.uuid === id
      );

      return access ? true : false;
    },

    isAssignedRole() {
      const role = Number(this.$store.state.auth.info.role);
      return (
        role === ROLES.CLIENTE_ADMIN ||
        role === ROLES.TALENTO_HUMANO ||
        role === ROLES.RESPONSABLE_OPERATIVO
      );
    },

    getCompanies() {
      const user = this.$store.state.auth;
      CompanyAPI.getCompanyByDesign(user.user.nodexum_id)
        .then((response) => {
          // console.log("Companies with sso user: ", response);

          this.accessCompanies = response.companies;
        })
        .catch((error) => {
          console.log("Error with companies in SST by SSO: ", error);
        });
    },

    fetch() {
      this.loading = true;
      this.query();
    },

    debouncedFetch() {
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
      }
      this.searchTimer = setTimeout(() => {
        this.page = 1;
        this.fetch();
      }, 350);
    },

    async query() {
      try {
        // Roles asignados via SST: el listado de empresas viene del SST
        // (tabla company_users), no del SSO.
        if (this.isAssignedRole()) {
          const info = JSON.parse(localStorage.getItem("info")) || {};
          if (!info.sstID) {
            this.companies = [];
            this.loading = false;
            return;
          }
          CompanyAPI.getCompaniesByUserSst(info.sstID)
            .then((response) => {
              const list = Array.isArray(response && response.data)
                ? response.data
                : [];
              const term = (this.search || "").toLowerCase();
              const filtered = term
                ? list.filter((c) =>
                    (c.social_reason || "").toLowerCase().includes(term)
                  )
                : list;
              this.companies = filtered;
              this.page = (response && response.current_page) || 1;
              this.lastPage = (response && response.last_page) || 1;
              this.loading = false;
            })
            .catch((error) => {
              console.log(error);
              this.companies = [];
              this.loading = false;
            });
          return;
        }

        // Resto de roles: listado tradicional via SSO.
        CompanySSOAPI.getCompaniesBySearch(this.page, this.search)
          .then((response) => {
            const ssoList = Array.isArray(response && response.data)
              ? response.data
              : [];

            this.page = (response && response.current_page) || this.page;
            this.lastPage = (response && response.last_page) || this.lastPage;

            if (ssoList.length === 0) {
              this.companies = [];
              this.loading = false;
              return;
            }

            CompanyAPI.getAllCompanies()
              .then((res) => {
                const sstList = (res && res.companies) || [];

                this.companies = ssoList.map((sso) => {
                  const sst = sstList.find((item) => item.uuid == sso.id) || {
                    uuid: sso.id,
                    legal_representative: null,
                    legal_representative_email: null,
                    arl_id: null,
                    company_classification_id: 5,
                  };
                  // El social_reason real vive en el SSO; el del SST (columna
                  // nueva) puede venir null y NO debe pisarlo.
                  return { ...sso, ...sst, social_reason: sst.social_reason || sso.social_reason };
                });
                this.loading = false;
              })
              .catch((error) => {
                console.log(error);
                this.loading = false;
              });
          })
          .catch((error) => {
            console.log(error);
            this.loading = false;
          });
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },

    selectCompany(company) {
      this.companySelected = company;

      this.$store.dispatch("company/removeCompany");

      this.$store.dispatch("company/addCompany", company);
      this.$store.dispatch("notification/clear");

      let url = window.location.href;
      let newUrl = url.split("/");

      newUrl = newUrl.slice(0, newUrl.length - 1);
      newUrl = newUrl.join("/");
      newUrl = `${newUrl}/${this.companySelected.uuid}`;

      let arrayUrl = url.split("/");
      arrayUrl = arrayUrl.slice(3, 5);
      arrayUrl = arrayUrl.join("/");

      arrayUrl === "forms/editar-empresa"
        ? (window.location.href = newUrl)
        : arrayUrl[6] > 0
        ? (window.location.href = `/forms/${this.companySelected.id}/registro-colaboradores`)
        : window.location.reload();
    },

    selectOpen() {
      if (!this.companySelected.uuid) {
        this.$bvModal.show("my-company");
        return;
      }

      // Para roles asignados via SST (6/7/8) no hacemos refresh contra el SSO:
      // el token es 'dev-*' o no tiene scope para el SSO, asi que la respuesta
      // viene vacia y pisariamos el localStorage con uuid undefined, lo que
      // hace que el modal se abra otra vez en cada navegacion.
      if (this.isAssignedRole()) {
        return;
      }

      CompanyAPI.getCompanyByUUID(this.companySelected.uuid)
        .then((response) => {
          let company = response[0] || null;

          let sstData = company || {
            personType: null,
            uuid: this.companySelected.id,
            arl_id: null,
            arl_certificate: "",
            company_classification_id: 5,
            legal_representative: null,
            legal_representative_email: null,
            id_diseno_sso: null,
          };

          CompanySSOAPI.getCompany(this.companySelected.uuid)
            .then((response) => {
              let ssoData = response;

              // Solo refrescamos uuid si el SSO realmente devolvio datos.
              // Si la respuesta esta vacia ({}) NO sobreescribimos.
              if (ssoData && ssoData.id) {
                sstData.uuid = ssoData.id;
                // El social_reason del SST (columna nueva) puede ser null; no
                // debe pisar el nombre real del SSO.
                const data = { ...ssoData, ...sstData, social_reason: sstData.social_reason || ssoData.social_reason };
                this.$store.dispatch("company/addCompany", data);
                this.$store.dispatch("notification/clear");
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    prev() {
      this.page = this.page === 1 ? this.page : this.page - 1;
      this.loading = true;
      this.fetch();
    },

    next() {
      this.page = this.page === this.lastPage ? this.page : this.page + 1;
      this.loading = true;
      this.fetch();
    },
  },
  mounted() {
    this.query();
    this.selectOpen();
    this.getCompanies();
  },
  beforeDestroy() {
    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
    }
  },
};
</script>

<template>
  <div>
    <b-nav-item-dropdown
      v-b-modal="'my-company'"
      right
      class="notification-list topbar-dropdown"
      menu-class="profile-dropdown"
      toggle-class="p-0"
    >
      <template slot="button-content" class="nav-link dropdown-toggle">
        <div class="nav-user mr-0">
          <span class="pro-user-name ml-1">
            {{
              companySelected.id
                ? $t(companySelected.social_reason || ("Empresa " + (companySelected.uuid || companySelected.id)))
                : $t("Seleccionar una empresa")
            }}
            <i class="mdi mdi-chevron-down"></i>
          </span>
        </div>
      </template>
    </b-nav-item-dropdown>

    <b-modal
      id="my-company"
      hide-footer
      title="Seleccione la empresa que va a gestionar"
    >
      <div>
        <b-form-input
          v-model="search"
          placeholder="Buscar..."
          class="mr-2 border border-top-0 border-left-0 border-right-0"
          @update="debouncedFetch"
        />
      </div>
      <div>
        <div v-if="loading">
          <div class="text-center pt-3">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
        <div v-else-if="!loading && companies.length === 0">
          <div class="text-center">
            <h6>No se encontraron empresas</h6>
          </div>
        </div>
        <div v-else>
          <div v-for="item in companies" :key="item.id">
            <button
              variant="outline-primary"
              @click="[selectCompany(item), $bvModal.hide('my-company')]"
              :disabled="!allowAccess(item.uuid)"
              :class="`btn ${
                companySelected
                  ? companySelected.id === item.id
                    ? 'btn-primary'
                    : 'btn-light'
                  : 'btn-light'
              } button block col-12 text-left`"
            >
              <i class="fe-user mr-2"></i>
              {{
                $t(
                  (item.social_reason || "").length > 50
                    ? item.social_reason.slice(0, 47) + "..."
                    : item.social_reason || ("Empresa " + (item.uuid || item.id))
                )
              }}
            </button>
          </div>
        </div>
        <hr />
        <div class="text-center m-0">
          <button
            :disabled="page <= 1"
            variant="outline-primary"
            class="btn btn-outline-primary mx-2"
            type="button"
            @click="prev"
          >
            Anterior
          </button>
          <span>
            {{ page }}
          </span>
          <button
            :disabled="page >= lastPage"
            variant="outline-primary"
            class="btn btn-outline-primary mx-2"
            type="button"
            @click="next"
          >
            Siguiente
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>
